module.exports = __webpack_public_path__ + "static/media/dot_007CBA.308fc635.svg";